import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
/** Never returned to any client — persisted server-side to detect refresh-token reuse. */
export const refreshTokenSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    tokenHash: z.string(),
    familyId: objectIdSchema,
    usedAt: isoDateSchema.nullable(),
    expiresAt: isoDateSchema,
    createdAt: isoDateSchema,
});
/** 5-minute single-use token embedded in the pairing QR code — never the raw API key. */
export const pairingTokenSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    tokenHash: z.string(),
    expiresAt: isoDateSchema,
    usedAt: isoDateSchema.nullable(),
    createdAt: isoDateSchema,
});
/** 24h single-use token emailed to verify a new account. */
export const emailVerificationTokenSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    tokenHash: z.string(),
    expiresAt: isoDateSchema,
    usedAt: isoDateSchema.nullable(),
    createdAt: isoDateSchema,
});
/** 30-minute single-use token for the forgot/reset password flow. */
export const passwordResetTokenSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    tokenHash: z.string(),
    expiresAt: isoDateSchema,
    usedAt: isoDateSchema.nullable(),
    createdAt: isoDateSchema,
});
export const PAIRING_TOKEN_TTL_MS = 5 * 60 * 1000;
export const REFRESH_TOKEN_TTL_MS = 30 * 24 * 60 * 60 * 1000;
export const ACCESS_TOKEN_TTL_SECONDS = 15 * 60;
export const EMAIL_VERIFICATION_TOKEN_TTL_MS = 24 * 60 * 60 * 1000;
export const PASSWORD_RESET_TOKEN_TTL_MS = 30 * 60 * 1000;
/** 7-day invite links — long enough for someone to act, short enough to limit open-link exposure. */
export const INVITATION_TOKEN_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const authTokensResponseSchema = z.object({
    accessToken: z.string(),
    accessTokenExpiresInSeconds: z.number().int(),
    // refreshToken is omitted here for the web flow (httpOnly cookie); mobile receives it in-body.
    refreshToken: z.string().optional(),
});
export const setup2faResponseSchema = z.object({
    secret: z.string(),
    otpauthUrl: z.string(),
    qrCodeDataUrl: z.string(),
});
export const verify2faSchema = z.object({ totpCode: z.string().length(6) });
export const disable2faSchema = z.object({ totpCode: z.string().length(6) });
/** Returned exactly once, when 2FA setup is confirmed — recovery codes are never retrievable again. */
export const verify2faResponseSchema = z.object({
    recoveryCodes: z.array(z.string()),
});
export const sessionSchema = z.object({
    id: objectIdSchema,
    familyId: objectIdSchema,
    createdAt: isoDateSchema,
    expiresAt: isoDateSchema,
    isCurrent: z.boolean(),
});
//# sourceMappingURL=auth-tokens.js.map